<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
//import axios from "@/axios";

export default {
  page: {
    title: "Red Points",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout
  },
  data() {
    return {};
  },
  beforeMount(){
    window.open("https://www.redpoints.cl", "blank");
    history.back();
  },
  methods: {}
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="title">
              <h4 class="card-tittle custom-title">Red Points</h4>
            </b-row>
            <b-row style="height: 700px;">
              <iframe
                  class="dp-full"
                  src="https://www.redpoints.cl"
              >
              </iframe>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom-title{
    margin:0 !important;
    font-weight: bold;
}
.title{
    padding: 15px;
}
.dp-full{
    width: 100%;
    height: 100%;
}
</style>
